import { XMarkIcon } from "@heroicons/react/24/solid";
import type { ReactNode } from "react";

import { Button } from "@/components/ui/Button";

type DismissibleSuggestionProps = {
  children: ReactNode;
  dismissLabel: string;
  icon?: ReactNode;
  onClick?: () => void;
  onDismiss: () => void;
};

export function DismissibleSuggestion({
  children,
  dismissLabel,
  icon,
  onClick,
  onDismiss,
}: DismissibleSuggestionProps) {
  return (
    <div className="app-dismissible-suggestion">
      {onClick ? (
        <Button
          type="button"
          variant="unstyled"
          onClick={onClick}
          className="app-dismissible-suggestion-action"
        >
          {icon}
          {children}
        </Button>
      ) : (
        <span className="app-dismissible-suggestion-label">{children}</span>
      )}
      <Button
        type="button"
        variant="unstyled"
        onClick={onDismiss}
        aria-label={`${dismissLabel}: ${String(children)}`}
        title={dismissLabel}
        className="app-dismissible-suggestion-dismiss"
      >
        <XMarkIcon className="size-3.5" />
      </Button>
    </div>
  );
}
